import React, { forwardRef, useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Calendar } from 'primereact/calendar';
import './WeekSelector.scss';

const WeekSelector = forwardRef(
	({ onApply, selectedWeek, minDate = moment().subtract(26, 'weeks'), maxDate = moment().add(104, 'weeks') }, ref) => {
		const [localDates, setLocalDates] = useState([]);
		const [hasChanges, setHasChanges] = useState(false);

		const parseSelectedWeek = (week) => {
			if (week && week.length > 0) {
				const [start, end] = week;
				const startOfWeek = moment(start.format('YYYY-MM-DD')).toDate();
				const endOfWeek = moment(end.format('YYYY-MM-DD')).toDate();
				setLocalDates([startOfWeek, endOfWeek]);
			}
		};
		useEffect(() => {
			parseSelectedWeek(selectedWeek);
		}, [selectedWeek]);

		const resetState = () => {
			setHasChanges(false);
			parseSelectedWeek(selectedWeek);
		};

		const hideModal = () => {
			resetState();
			ref?.current?.hide();
		};

		const onDateChange = (event) => {
			if (event.value && event.value.length > 0) {
				const [firstDate] = event.value;
				const startOfWeek = moment(firstDate).startOf('week').toDate();
				const endOfWeek = moment(firstDate).endOf('week').toDate();
				setLocalDates([startOfWeek, endOfWeek]);
			} else {
				setLocalDates([]);
			}
			setHasChanges(true);
		};

		const handleApply = () => {
			if (localDates.length > 0) {
				const [startDate, endDate] = localDates;
				const appliedDates = [moment(startDate), moment(endDate)];
				const periodIndex = Math.ceil(moment(startDate).diff(moment().startOf('day'), 'weeks', true));
				onApply({ range: appliedDates, periodIndex });
			} else {
				onApply(null);
			}
		};

		const canApply = hasChanges && !!localDates.length;

		return (
			<OverlayPanel ref={ref} className="week-selector" onHide={resetState}>
				<Calendar
					value={localDates}
					onChange={onDateChange}
					selectionMode="range"
					showOtherMonths
					numberOfMonths={1}
					minDate={minDate.toDate()}
					maxDate={maxDate.toDate()}
					readOnlyInput
					inline
				/>

				<div className="week-selector-actions">
					<div className="week-selector-actions__text">
						{localDates.length > 0
							? `${moment(localDates[0]).format('MMM D')} - ${moment(localDates[1]).format('MMM D')}`
							: 'No week selected'}
					</div>
					<div className="week-selector-actions__buttons">
						<button type="button" className="button button-secondary" onClick={hideModal}>
							Cancel
						</button>
						<button type="button" className="button button-primary" onClick={handleApply} disabled={!canApply}>
							Done
						</button>
					</div>
				</div>
			</OverlayPanel>
		);
	}
);

export default WeekSelector;
